import { render } from "./case.vue?vue&type=template&id=07db5454"
import script from "./case.vue?vue&type=script&lang=ts"
export * from "./case.vue?vue&type=script&lang=ts"

import "./case.vue?vue&type=style&index=0&id=07db5454&lang=css"
script.render = render

export default script